import axios from 'axios'
import settings from '../../settings'
const slider = {
    namespaced: true,
    state: () => ({
        count: 0,
        all:[],
        search:[]
      }),
      mutations:{
         updateSliderState(state,data){
             state.all=data;
         },
         updateSearchState(state,data){
             state.search=data;
         },
      },
      actions: {
        fetchSliders({commit}){
            axios.get(`${settings.apiUrl}/slider`).then(res => {
					commit('updateSliderState',res.data)
			 });
        },
        search({commit},query){
            axios.get(`${settings.apiUrl}/slider?search=${query}`).then(res => {
				 	commit('updateSearchState',res.data)
			 });
        },
      },
    
      getters: {
           
      }
}

export default slider;

 